import { rootApi } from '../rootApi';

/**
 * LMS Eğitim Raporları — `/v1/LmsTrainingReport`.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md §3.
 *
 * Bir rapor kaydı ana kayıttır; maliyet (`LmsTrainingReportCost`), katılımcı
 * (`LmsTrainingReportParticipant`) ve eğitmen (`LmsTrainingReportInstructor`) satırları
 * `trainingReportId` ile rapora bağlanır. Rapor silinince bu üç alt tablo da (backend
 * tarafında) silinir (doc §1.8, §3.8) — bu yüzden silme ilgili tag'leri de invalidate eder.
 */
export const lmsTrainingReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingReports: builder.query({
            query: ({ catalogPlanningId, country, planningLocation, vehicleModel, trainingType, reportType, trainingStartDateFrom, trainingStartDateTo, status, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingReport/GetList',
                method: 'POST',
                body: {
                    catalogPlanningId: catalogPlanningId ?? null,
                    country: country || null,
                    planningLocation: planningLocation || null,
                    vehicleModel: vehicleModel || null,
                    trainingType: trainingType || null,
                    reportType: reportType || null,
                    trainingStartDateFrom: trainingStartDateFrom || null,
                    trainingStartDateTo: trainingStartDateTo || null,
                    status: status ?? null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingReport']
        }),

        getLmsTrainingReportById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingReport/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingReport']
        }),

        // Rapor + maliyetler + katılımcılar + eğitmenler tek istekte (doc §3.6).
        getLmsTrainingReportDetailById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingReport/GetDetailById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingReport', 'LmsTrainingReportCost', 'LmsTrainingReportParticipant', 'LmsTrainingReportInstructor']
        }),

        addLmsTrainingReport: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReport/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReport']
        }),

        updateLmsTrainingReport: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReport/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReport']
        }),

        deleteLmsTrainingReport: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingReport/${id}`,
                method: 'DELETE'
            }),
            // Rapor silinince alt satırlar da (backend tarafında) silinir (doc §1.8, §3.8)
            invalidatesTags: ['LmsTrainingReport', 'LmsTrainingReportCost', 'LmsTrainingReportParticipant', 'LmsTrainingReportInstructor']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingReportsQuery,
    useGetLmsTrainingReportByIdQuery,
    useGetLmsTrainingReportDetailByIdQuery,
    useAddLmsTrainingReportMutation,
    useUpdateLmsTrainingReportMutation,
    useDeleteLmsTrainingReportMutation
} = lmsTrainingReportApi;
